import { api } from '@api'
import { FetchParams, PaginatedResponse, Profession } from './types'
import { usePaginate } from './usePaginate'

const fetchProfessions = async ({ pageParam = '0', search, sectorId }: FetchParams): Promise<PaginatedResponse<Profession>> => {
  let url = `/professions?page=${pageParam}`
  if (search) url += `&search=${encodeURIComponent(search)}`
  if (sectorId) url += `&sectorId=${sectorId}`
  
  const { data } = await api.get<PaginatedResponse<Profession>>(url)
  return data
}

export const usePaginateProfessions = (search?: string, sectorId?: string) => {
  return usePaginate<Profession>('professions', fetchProfessions, { search, sectorId })
}

